import { publicCreateReturnRequest } from "@babackapp/private-api-client/client/use-public-create-return-request";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildReturnRequestPayload } from "../lib/return-request.lib";
import type { ReturnDraft } from "../types";

export function useCreateReturnRequest(orderId: string, shopSlug: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (draft: ReturnDraft) =>
      publicCreateReturnRequest(buildReturnRequestPayload(draft)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "get",
          "/public/return-request/search",
          { params: { query: { orderId, shopSlug } } },
        ],
      });
    },
  });
}
